import { all } from "redux-saga/effects";
import { combineReducers } from "redux";
import * as auth from "../app/modules/Auth/_redux/authRedux";
import lessonReducer from "./reducers/lessons";
import instructorsReducer from "./reducers/instructors";
import levelReducer from "./reducers/levels";
import locationsReducer from "./reducers/locations";
import programsReducer from "./reducers/programs";
import venuesReducer from "./reducers/venues";
import parentReducer from "./reducers/parents";
import studentReducer from "./reducers/students";
import lessonTypesReducer from "./reducers/lessonTypes";
import enrolmentReducer from "./reducers/enrolments";
import settingReducer from "./reducers/settings";
import classReducer from "./reducers/classes";
import tutorReducer from "./reducers/tutors";
import organisationReducer from "./reducers/organisations";
import attendanceReducer from "./reducers/attendance";
import publicHolidaysReducer from "./reducers/publicholidays";
import categoriesReducer from "./reducers/categories";
import productsReducer from "./reducers/products";
import notificationsReducer from "./reducers/notifications";
import birthdayPartyReducer from "./reducers/birthdayParty";
import orderReducer from "./reducers/orders";
import loaderReducer from "./reducers/loader";
import waitingListReducer from "./reducers/waitingList";
import bookingReducer from "./reducers/booking";
import inflatableReducer from "./reducers/inflatable";
import couponReducer from "./reducers/coupon";
import bookaCoachReducer from "./reducers/bookacoach";
import playReducer from "./reducers/play";
import emailTemplateReducer from "./reducers/emailTemplate";
import locationSurchargeReducer from "./reducers/locationSurcharge";
import teamsReducer from "./reducers/teams";
import embedCodeReducer from "./reducers/embedCode";
import taskReducer from "./reducers/tasks";
import trialsReducer from "./reducers/trials";
import makeupLessonReducer from "./reducers/makeupLesson";
import serviceReducer from "./reducers/service";
import termsReducer from "./reducers/terms";
import alertReducer from "./reducers/alert";
import feedbackReducer from "./reducers/feedback";
import paymentReducer from "./reducers/payments";
import notesReducer from "./reducers/notes";
import ageReducer from "./reducers/age";
import regionReducer from "./reducers/regions";
import cronReducer from "./reducers/cronJobs";
import bookingSettingsReducer from "./reducers/bookingSettings";
import transactionsReducer from "./reducers/transaction";
import priceReducer from "./reducers/price";
import listReducer from "./reducers/list";
import contactReducer from "./reducers/contact";
import rolesReducer from "./reducers/roles";

import ageSaga from "./sagas/age";
import lessonSaga from "./sagas/lessons";
import instructorSaga from "./sagas/instructors";
import levelSaga from "./sagas/levels";
import locationsSaga from "./sagas/locations";
import programsSaga from "./sagas/programs";
import venuesSaga from "./sagas/venues";
import parentsSaga from "./sagas/parents";
import studentsSaga from "./sagas/students";
import lessonTypesSaga from "./sagas/lessonTypes";
import enrolmentSaga from "./sagas/enrolments";
import settingSaga from "./sagas/settings";
import classSaga from "./sagas/classes";
import tutorsSaga from "./sagas/tutors";
import organisationsSaga from "./sagas/organisations";
import attendanceSaga from "./sagas/attendance";
import publicHolidaysSaga from "./sagas/publicholidays";
import categoriesSaga from "./sagas/categories";
import productsSaga from "./sagas/products";
import notificationSaga from "./sagas/notifications";
import birthdayPartySaga from "./sagas/birthdayParty";
import orderSaga from "./sagas/orders";
import waitingListSaga from "./sagas/waitingList";
import bookingSaga from "./sagas/booking";
import inflatableSaga from "./sagas/inflatable";
import couponSaga from "./sagas/coupon";
import bookaCoachSaga from "./sagas/bookacoach";
import playSaga from "./sagas/play";
import emailTemplateSaga from "./sagas/emailTemplate";
import locationSurchargeSaga from "./sagas/locationSurcharge";
import teamsSaga from "./sagas/teams";
import embedCodeSaga from "./sagas/embedCode";
import taskSaga from "./sagas/tasks";
import trialsSaga from "./sagas/trials";
import makeupLessonSaga from "./sagas/makeupLesson";
import serviceSaga from "./sagas/service";
import termsSaga from "./sagas/terms";
import alertSaga from "./sagas/alert";
import feedbackSaga from "./sagas/feedback";
import paymentsSaga from "./sagas/payments";
import notesSaga from "./sagas/notes";
import regionSaga from "./sagas/regions";
import cronsSaga from "./sagas/cronJobs";
import bookingSettingsSaga from "./sagas/bookingSettings";
import transactionSaga from "./sagas/transaction";
import priceSaga from "./sagas/price";
import listSaga from "./sagas/list";
import contactSaga from "./sagas/contact";
import RolesSaga from "./sagas/roles";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  enrolments: enrolmentReducer,
  lessons: lessonReducer,
  instructors: instructorsReducer,
  levels: levelReducer,
  locations: locationsReducer,
  programs: programsReducer,
  venues: venuesReducer,
  parents: parentReducer,
  students: studentReducer,
  lessonTypes: lessonTypesReducer,
  settings: settingReducer,
  classes: classReducer,
  tutors: tutorReducer,
  organisations: organisationReducer,
  attendance: attendanceReducer,
  publicHolidays: publicHolidaysReducer,
  categories: categoriesReducer,
  products: productsReducer,
  notifications: notificationsReducer,
  loader: loaderReducer,
  birthdayParty: birthdayPartyReducer,
  orders: orderReducer,
  waitingList: waitingListReducer,
  booking: bookingReducer,
  inflatable: inflatableReducer,
  coupon: couponReducer,
  bookaCoach: bookaCoachReducer,
  play: playReducer,
  emailTemplate: emailTemplateReducer,
  locationSurcharge: locationSurchargeReducer,
  teams: teamsReducer,
  embedCode: embedCodeReducer,
  tasks: taskReducer,
  makeupLessons: makeupLessonReducer,
  service: serviceReducer,
  terms: termsReducer,
  alert: alertReducer,
  feedback: feedbackReducer,
  payments: paymentReducer,
  trials: trialsReducer,
  notes: notesReducer,
  age: ageReducer,
  regions: regionReducer,
  crons: cronReducer,
  bookingSettings: bookingSettingsReducer,
  transactions: transactionsReducer,
  prices: priceReducer,
  lists: listReducer,
  contacts: contactReducer,
  roles: rolesReducer,
});

export function* rootSaga() {
  yield all([
    auth.saga(),
    lessonSaga(),
    instructorSaga(),
    levelSaga(),
    locationsSaga(),
    programsSaga(),
    venuesSaga(),
    parentsSaga(),
    studentsSaga(),
    lessonTypesSaga(),
    enrolmentSaga(),
    settingSaga(),
    classSaga(),
    tutorsSaga(),
    organisationsSaga(),
    attendanceSaga(),
    publicHolidaysSaga(),
    categoriesSaga(),
    productsSaga(),
    notificationSaga(),
    birthdayPartySaga(),
    orderSaga(),
    waitingListSaga(),
    bookingSaga(),
    inflatableSaga(),
    couponSaga(),
    bookaCoachSaga(),
    playSaga(),
    emailTemplateSaga(),
    locationSurchargeSaga(),
    teamsSaga(),
    embedCodeSaga(),
    taskSaga(),
    makeupLessonSaga(),
    serviceSaga(),
    termsSaga(),
    alertSaga(),
    feedbackSaga(),
    paymentsSaga(),
    trialsSaga(),
    notesSaga(),
    ageSaga(),
    regionSaga(),
    cronsSaga(),
    bookingSettingsSaga(),
    transactionSaga(),
    priceSaga(),
    listSaga(),
    contactSaga(),
    RolesSaga(),
  ]);
}
